import {
  FETCH_REQUIRED_FILTER_TYPE_NAMES,
  FORECAST_TIMELINE_FILTER_TYPE_NAMES,
  NO_FETCH_REQUIRED_FILTER_TYPE_NAMES,
  UNMANAGED_FILTER_TYPE_NAMES,
} from '../constants';

/**
 * apiを叩いて一覧データを取得する必要があるフィルターアイテムのタイプ
 * 追加する際はconstantsの方に追加してください
 */
export type FetchRequiredFilterType = (typeof FETCH_REQUIRED_FILTER_TYPE_NAMES)[number];

/**
 * 集計取引のフィルタプロパティ
 * FIXME: TSDoc書く
 */
export interface AggregateBusinessFilterProperty {
  supplierName: string | undefined;
  supplierCode: string | undefined;
  businessCode: string | undefined;
  businessName: string | undefined;
  packageAmount: string | undefined;
  warehouse: string | undefined;
  warehouseCode: string | undefined;
  unit: string | undefined;
  leadTime: number | undefined;
  leadTimeUnit: string | undefined;
  stdInventoryIndicesMin: number | undefined;
  stdInventoryIndicesMax: number | undefined;
  stdInventoryIndicesUnit: string | undefined;
  MOQ: number | undefined;
  manufacturer: string | undefined;
  supplierForecastResponsibleUserId: string | undefined;
  orderPackage: string | undefined;
}

export const initialAggregateBusinessFilterProperty: AggregateBusinessFilterProperty = {
  supplierName: undefined,
  supplierCode: undefined,
  businessCode: undefined,
  businessName: undefined,
  packageAmount: undefined,
  warehouse: undefined,
  warehouseCode: undefined,
  unit: undefined,
  leadTime: undefined,
  leadTimeUnit: undefined,
  stdInventoryIndicesMin: undefined,
  stdInventoryIndicesMax: undefined,
  stdInventoryIndicesUnit: undefined,
  MOQ: undefined,
  manufacturer: undefined,
  supplierForecastResponsibleUserId: undefined,
  orderPackage: undefined,
};

/**
 * データのフェッチが不要なフィルタータイプ
 * 追加する際はconstantsの方に追加してください
 */
export type NoFetchRequiredFilterType = (typeof NO_FETCH_REQUIRED_FILTER_TYPE_NAMES)[number];

/**
 * FilterType
 */
export type FilterType = FetchRequiredFilterType | NoFetchRequiredFilterType;

/**
 * あるstringがfilterTypeに含まれているかをチェックする
 * @param value - 判定する文字列
 */
export const isFilterType = (value: string): value is FilterType => {
  return (
    (NO_FETCH_REQUIRED_FILTER_TYPE_NAMES as readonly string[]).includes(value) ||
    (FETCH_REQUIRED_FILTER_TYPE_NAMES as readonly string[]).includes(value)
  );
};

/**
 * フィルタータイプがフェッチが必要かどうかを判定する
 * @param filterType - フィルタータイプ
 */
export const isFetchRequiredFilterType = (filterType: FilterType): filterType is FetchRequiredFilterType => {
  return FETCH_REQUIRED_FILTER_TYPE_NAMES.some((name) => name === filterType);
};

/**
 * 未管理に関連するフィルタータイプ名
 */
export type UnmanagedBusinessFilterType = (typeof UNMANAGED_FILTER_TYPE_NAMES)[number];

/**
 * 内示遍歴で使用するフィルタータイプ名
 */
export type ForecastTimelineFilterType = (typeof FORECAST_TIMELINE_FILTER_TYPE_NAMES)[number];

/**
 * 内示遍歴のフィルタプロパティ
 */
export interface ForecastTimelineFilterProperty {
  staffName: string | undefined;
  warehouseCode: string | undefined;
  warehouse: string | undefined;
  supplierCode: string | undefined;
  supplierName: string | undefined;
  businessCode: string | undefined;
  businessName: string | undefined;
  packageAmount: number | undefined;
  customerCode: string | undefined;
  customerName: string | undefined;
  salesDestinationCode: string | undefined;
  salesDestinationName: string | undefined;
}

/**
 * 必須の内示遍歴フィルタプロパティ
 */
export interface RequiredForecastTimelineFilterProperty {
  // staffName: string;
  warehouseCode: string;
  warehouse: string;
  supplierCode: string;
  supplierName: string;
  businessCode: string;
  businessName: string;
  packageAmount: number;
  customerCode: string;
  customerName: string;
  salesDestinationCode: string;
  salesDestinationName: string;
}
